import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    deleteLogo: 'Remove logo',
    replaceLogo: 'Replace logo',
  },
  fr: {
    deleteLogo: 'Supprimer le logo',
    replaceLogo: 'Remplacer le logo',
  },
} as const);

export default locales;
